import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification, NotificationType } from '../../models/notification-models';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    animations: [
        trigger('openClose', [
            transition(':enter', [
                style({
                    transform: 'rotate(90deg)',
                    opacity: 0,
                }),
                animate('500ms cubic-bezier(.23,1.25,.54,1.05)', style({
                    transform: 'rotate(0deg)',
                    opacity: 1,
                })),
            ]),
            transition(':leave', [
                animate('600ms cubic-bezier(.23,-0.10,.54,.18)', style({
                    transform: 'rotate(90deg)',
                    opacity: 0,
                })),
            ]),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationsComponent implements OnInit {
  notification: Notification;
  showMessage: boolean;

  @Input() trigger: Subject<Notification>;

  NotificationType: typeof NotificationType = NotificationType;

  constructor() {}

  ngOnInit(): void {
    if (this.trigger) {
      this.trigger.subscribe((notification: Notification) => {
        this.show(notification);
      });
    }
  }

  public show(notification: Notification) {
    this.notification = notification;
    this.showMessage = true;
    if (notification.duration > 0) {
      setTimeout(() => this.dismiss(false), notification.duration);
    }
  }

  public dismiss(dismissedByAction: boolean) {
    if (!this.notification) return;
    this.notification.dismissed$.next({
      dismissedByAction: dismissedByAction,
      notification: this.notification,
    });

    this.notification = undefined;
    this.showMessage = false;
  }
}
